import React, { useState, useCallback } from 'react'
import { useTheme } from '@/context/ThemeContext'
import Field from './Field'
import SaveBtn from './SaveBtn'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'

const PasswordSection: React.FC = () => {
  const { currentTheme: t } = useTheme()
  const [notice, setNotice] = useState(false)

  const closeNotice = useCallback(() => setNotice(false), [])

  return (
    <div>
      <div className="flex flex-col gap-5 mb-7">
        <Field label="Current password" type="password" placeholder="••••••••" />
        <Field label="New password" type="password" placeholder="At least 8 characters" />
        <Field label="Confirm new password" type="password" placeholder="Repeat new password" />
      </div>

      <SaveBtn label="Update password" fullWidth onClick={() => setNotice(true)} />

      <Dialog open={notice} onOpenChange={setNotice}>
        <DialogContent
          className="py-6 px-8 rounded-2xl shadow-xl max-w-sm w-full border-none"
          style={{ background: t.secondary, color: t.text }}
        >
          <DialogHeader>
            <DialogTitle className="text-lg font-semibold text-center" style={{ color: t.text }}>
              Password changes aren't available yet
            </DialogTitle>
          </DialogHeader>
          <p className="text-sm text-center mt-1" style={{ color: t.mutedText }}>
            Contact support if you need to reset your password.
          </p>
          <DialogFooter className="flex justify-center mt-6">
            <Button
              variant="secondary"
              onClick={closeNotice}
              className="px-5 py-2 rounded-lg font-medium h-auto text-sm"
              style={{ background: t.hoverBackground, color: t.text, border: `1px solid ${t.border}` }}
            >
              OK
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  )
}

export default React.memo(PasswordSection)
